export default __webpack_public_path__ + "static/media/education_3.21deff4e.png";